import { Grid } from "@mui/material";
import React, { ReactNode, useRef, useState } from "react";
import { Navigation, Pagination, Grid as SwiperGrid } from "swiper/modules";
import { Swiper, SwiperRef } from "swiper/react";
import { Swiper as SwiperType } from "swiper/types";
import useUiStore from "../../../stores/useUiStore";
import NextButton from "./NextButton";
import PrevButton from "./PrevButton";

type TOwnProps = {
  children?: ReactNode;
  total: number;
};

type TNavigationState = {
  hidePrev?: boolean;
  hideNext?: boolean;
};

const Carousel = (props: TOwnProps) => {
  const { children, total } = props;
  const { isDesktop, isMobile } = useUiStore();
  let swiperRef = useRef<SwiperRef>(null);

  const [navigationState, setNavigationState] = useState<TNavigationState>({
    hidePrev: true,
    hideNext: false,
  });

  const ROWS = total > 4 ? 2 : 1;
  const slidePerView = isMobile ? 1 : isDesktop ? 4 : 2;

  const hasNavigator = total / ROWS > slidePerView;

  const onNavigate = (isNext: boolean) => {
    if (swiperRef.current) {
      isNext
        ? swiperRef.current.swiper.slideNext()
        : swiperRef.current.swiper.slidePrev();
    }
  };

  const onSlideChange = (swiper: SwiperType) => {
    setNavigationState({
      hidePrev: swiper.isBeginning,
      hideNext: swiper.isEnd,
    });
  };

  const renderCarousel = () => {
    return (
      <Swiper
        ref={swiperRef}
        allowTouchMove
        breakpoints={{
          300: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 4,
          },
        }}
        grid={{
          rows: ROWS,
          fill: "row",
        }}
        loopAddBlankSlides
        pagination={{
          clickable: true,
        }}
        spaceBetween={20}
        modules={[SwiperGrid, Pagination, Navigation]}
        className="swiper"
        style={{
          marginTop: "1rem",
          height: "100%",
          paddingBottom: "4rem",
          backgroundColor: "transparent",
        }}
        onSlideChange={onSlideChange}
      >
        {children}
      </Swiper>
    );
  };

  return (
    <Grid
      item
      container
      direction="row"
      columnSpacing={2}
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid item xs={1}>
        {!isMobile && hasNavigator && !navigationState.hidePrev && (
          <PrevButton
            onClick={() => {
              onNavigate(false);
            }}
          />
        )}
      </Grid>
      <Grid item md={10} xs={12} margin="auto">
        {renderCarousel()}
      </Grid>
      <Grid item xs={1}>
        {!isMobile && hasNavigator && !navigationState.hideNext && (
          <NextButton
            onClick={() => {
              onNavigate(true);
            }}
          />
        )}
      </Grid>

      {isMobile && hasNavigator && (
        <Grid container item justifyContent="center" alignItems="center">
          {!navigationState.hidePrev && (
            <Grid item>
              <PrevButton
                onClick={() => {
                  onNavigate(false);
                }}
              />
            </Grid>
          )}
          {!navigationState.hideNext && (
            <Grid item>
              <NextButton
                onClick={() => {
                  onNavigate(true);
                }}
              />
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  );
};
export default Carousel;
